// export default PointLadgerTable;
import React, { useEffect } from "react";
import $ from "jquery";
import "datatables.net";
import { useNavigate } from "react-router-dom"; // add this import

const PointLadgerTable = ({ tableId, ajaxUrl, columns }) => {
  const navigate = useNavigate(); //  initialize navigate

  useEffect(() => {
    let dataTableInstance;

    const loadScriptAndInitialize = async () => {
      try {
        const module = await import("../../../datatable.js"); // Dynamically import
        const initFunc = module.initializeDataTable || window.initializeDataTable;

        if (typeof initFunc === "function") {
          dataTableInstance = initFunc({
            selector: `#${tableId}`,
            columns,
            ajaxUrl,
          });
        }

      } catch (error) {
        console.error("Failed to load or initialize datatable.js:", error);
      }
    };

    loadScriptAndInitialize();

    const handleBillingUpdate = () => {
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`).DataTable().ajax.reload(); // reload table
      }
    };
    //  LISTENER

    window.addEventListener("billingUpdated", handleBillingUpdate);

    return () => {
      // Clean up on unmount
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`).DataTable().destroy(true);
      }

      // Remove event listener to avoid duplicates
      $(document).off("click", `#${tableId} .invoice-number`);
      window.removeEventListener("billingUpdated", handleBillingUpdate);
    };
  }, [tableId, ajaxUrl, columns, navigate]);

  return (
    <>
      <h5 className="kpi-heading">Invoices</h5>
      <table id={tableId} className="display">
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th key={index}>{col.title || col.data}</th>
            ))}
          </tr>
        </thead>
      </table>
    </>
  );
};

export default PointLadgerTable;

